import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ICalc } from "../../model";

export const CalcSelect = Select.ofType<ICalc>();

export const filterEmpresa: ItemPredicate<ICalc> = (query, calc) => {
  return calc.nome.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderCalc: ItemRenderer<ICalc> = (
  calc,
  { handleClick, modifiers },
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={calc.id}
      text={calc.nome}
      onClick={handleClick}
      label={calc.nome}
    />
  );
};
